import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../../common/models';
import { HubLoanerPhoneItemState } from './hub-loaner-phone-item.state';
import {
  HubLoanerPhoneItemCreate,
  HubLoanerPhoneItemDelete,
  HubLoanerPhoneItemInitialState,
  HubLoanerPhoneItemLoad,
  HubLoanerPhoneItemReturn,
  HubLoanerPhoneItemUpdate,
} from './hub-loaner-phone-item.actions';
import { HubLoanerPhoneListItem } from '../../../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class HubLoanerPhoneItemFacade implements LoadDataFacade, SetInitialStateFacade {
  loanerPhoneItem$: Observable<HubLoanerPhoneListItem> = this.store.select(HubLoanerPhoneItemState.getLoanerPhoneItem);
  loaded$: Observable<boolean> = this.store.select(HubLoanerPhoneItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll({ hubId, phoneId }: { hubId: number; phoneId: number }): void {
    this.store.dispatch(new HubLoanerPhoneItemLoad({ hubId, id: phoneId }));
  }

  returnLoanerPhoneItem(
    dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>,
    hubId: number,
    id: number,
    returnTimestamp: number,
  ): void {
    this.store.dispatch(new HubLoanerPhoneItemReturn({ dialog, hubId, id, returnTimestamp }));
  }

  createLoanerPhoneItem(hubId: number, loanerPhoneItem: HubLoanerPhoneListItem): void {
    this.store.dispatch(new HubLoanerPhoneItemCreate({ hubId, loanerPhoneItem }));
  }

  updateLoanerPhoneItem(hubId: number, loanerPhoneItem: HubLoanerPhoneListItem): void {
    this.store.dispatch(new HubLoanerPhoneItemUpdate({ hubId, loanerPhoneItem }));
  }

  deleteLoanerPhoneItem(dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>, hubId: number, id: number): void {
    this.store.dispatch(new HubLoanerPhoneItemDelete({ dialog, hubId, id }));
  }

  setInitialState(): void {
    this.store.dispatch(new HubLoanerPhoneItemInitialState());
  }
}
